// Brokerage HR Dashboard helpers (#648).
import moment from 'moment'

export const SCORE_COLUMNS = [
    { key: 'polite', label: 'Polite' },
    { key: 'knowledgeable', label: 'Knowledgeable' },
    { key: 'on_time', label: 'On time' },
    { key: 'answered_questions', label: 'Answered Qs' },
    { key: 'above_and_beyond', label: 'Above & beyond' },
    { key: 'recommend', label: 'Recommend' },
]

// "4.8 (40)": an average always shows how many answers it rests on.
export function formatScore (cell) {
    if (!cell || cell.avg === null || cell.avg === undefined) return '–'
    return `${cell.avg.toFixed(1)} (${cell.n})`
}

export function formatNps (nps) {
    if (nps === null || nps === undefined) return '–'
    return nps > 0 ? `+${nps}` : `${nps}`
}

export function defaultRange (today = moment()) {
    const end = moment(today)
    return { start: moment(end).subtract(90, 'days').format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD') }
}

// A cleared date input is '', which the API would reject as a date.
export function cleanParams (params) {
    return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined))
}

// Copy and say so. A refusal (no permission, an old browser) is not an error:
// the caller keeps the link on screen to copy by hand.
export async function copyText (store, text) {
    try {
        await navigator.clipboard.writeText(text)
        store.commit('pushAlert', { message: 'Copied!', timeout: 800, variant: 'success' })
        return true
    } catch (e) {
        return false
    }
}
